/**
 * @owner @Appboy/frontend-ix
 */

/** This HTTP status code is used to flag errors that occurred from Pusher. This allows us to avoid retrying on these errors */
export const PUSHER_ERROR_STATUS = 424;
export const PUSHER_SUBSCRIPTION_SUCCEEDED = "pusher:subscription_succeeded";
